import Proptypes from 'prop-types'
import { useState } from 'react'
import { Helmet } from 'react-helmet'
import ReactHtmlParser from 'react-html-parser'

import { StyledContainer, StyledOutlinedContainer } from './styles'

export const Framed = ({ text, style = {}, themeInfos }) => {
  const [ogDescription, setOgDescritpion] = useState(false)
  const { alternate = false, borderWidth = 3, borderRadius = 10, themeColor, useThemeColor} = style;

  if(text == null) return null

  const Container = alternate ? StyledOutlinedContainer : StyledContainer;

  const getTmp = () => {
    if (!ogDescription) {
      setOgDescritpion(true)
      return (
        <Helmet>
          <meta property="og:description" content={text.split('\n')[0]} />
        </Helmet>
      )
    }
  }

  return (
    <Container $borderRadius={borderRadius} $borderWidth={borderWidth} $themeCustom={themeInfos} $themeColor={themeColor} $useThemeColor={useThemeColor}>
      {getTmp()}
      {ReactHtmlParser(text)}
    </Container>
  )
}

Framed.propTypes = {
  text: Proptypes.any,
  style: Proptypes.object,
  themeInfos: Proptypes.object,
}

export default Framed
